export const environment = {
  DEV: 'dev',
  STAGING: 'staging',
  PROD: 'prod',
} as const;

export type Environment = (typeof environment)[keyof typeof environment];

export type GrowthbookConfig = Record<
  Environment,
  {apiHost: string; clientKey: string}
>;

export type Config = {
  environment: Environment;
  branch: string;
  commit: string;
  growthbook: GrowthbookConfig[Environment];
  twEnvName?: string;
  version?: string;
};

export interface EventData {
  category: string;
  property: string;
  action: string;
  label?: string;
  value?: string;
}
export type GtmPageViewParams = {
  page: {
    countryCode: string;
    language?: string;
    environment: string;
    channelEnvironment: string;
    channel: string;
    channelType: string;
    isTreatwellBrandedWidget: boolean;
    view: string;
    platformCode: string;
    type: string;
    gtmId: string;
  };
};

export type GtmParams = GtmPageViewParams;

export type GtmTrackEvent = {
  event: 'trackEvent' | 'authenticationState';
  eventData: EventData;
  eventCallback?: () => void;
  eventTimeout?: number;
};

export type GtmEvent = {
  event: 'gtm.js';
  'gtm.start': number;
};

export type GtmPayLoad = GtmParams | GtmTrackEvent | GtmEvent;

export type DataLayer = GtmPayLoad[];

export const X_LANGUAGE_CODE = 'x-language-code';
export const X_CSRF_TOKEN = 'x-csrf-token';
